module.exports = __webpack_public_path__ + "static/media/video.d4603750.mp4";